import deepmerge from "ts-deepmerge";
import { settings as DefaultSettings } from "../nuxt-kommunen.config.mjs";
import { settings } from "@/nuxt-kommunen.config";
function defineSettings(componentName) {
  const customComponentSettings = settings[componentName] || {};
  const defaultComponentSettings = DefaultSettings[componentName] || {};
  const combinedSettings = deepmerge(
    defaultComponentSettings,
    customComponentSettings
  );
  return combinedSettings;
}
export { defineSettings };
